import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { compoundActions, getCompounds } from "data/compoundApi"

class WithCompounds extends React.Component {
    render() {
        const compoundsData = this.props.compounds
        if (!compoundsData) return this.props.loading ? this.props.loading : ""
        const compounds = Object.values(compoundsData)
        return this.props.children({
            compounds,
        })
    }

    constructor(props) {
        super(props)
        props.compoundActions.fetch()
    }
}

WithCompounds.propTypes = {}

function mapStateToProps(state) {
    return {
        compounds: getCompounds(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        compoundActions: bindActionCreators(compoundActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithCompounds)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithCompounds.js